import React, { useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import OrganizationPreview from "../../components/Organization/OrganizationPreview";
import { ReactComponent as HomeIcon } from "../../assets/icons/home-line.svg";
import { ReactComponent as ChevronRight } from "../../assets/icons/chevron-right.svg";

//Ths component represents the new Navbar for the Asset Dashboard for now. it will be refoctored later to be used across the app. mike t

type NewNavbarProps = {
  organization?: any;
  groupName?: string;
  assetName?: string;
};

const NewNavbar = ({ organization, groupName, assetName }: NewNavbarProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { groupid } = useParams();

  const breadcrumbItems = useMemo(() => {
    const path = location.pathname;
    const items: Array<{
      label: string;
      path: string | null;
      icon?: typeof HomeIcon;
    }> = [
      {
        label: "Home",
        path: "/home",
        icon: HomeIcon
      }
    ];

    // Check if we're on the new dashboard
    if (path.includes("/home/new-dashboard")) {
      items.push({
        label: "Dashboard",
        path: null // Current page if on dashboard
      });
    }

    // Check if we're on asset dashboard
    if (path.includes("/home/asset-dashboard")) {
      items.push({
        label: groupName || "Asset Dashboard",
        path: path.includes("/home/asset-dashboard") && !path.includes("/asset/") ? null : (groupid ? `/home/asset-dashboard/${groupid}` : "/home/asset-dashboard")
      });
    }

    // Check if we're on the asset page
    if (path.includes("/home/asset-page/") || (path.includes("/home/group/") && path.includes("/asset/"))) {
      // Add group/dashboard link if not already there
      if (!items.find(item => item.path?.includes("/home/asset-dashboard"))) {
        items.push({
          label: groupName || "Asset Dashboard",
          path: groupid ? `/home/asset-dashboard/${groupid}` : "/home/asset-dashboard"
        });
      }
      items.push({
        label: assetName || "Asset Page",
        path: null // Current page, not clickable
      });
    }

    return items;
  }, [location.pathname, groupid, groupName, assetName]);

  return (
    <div className="bg-white border border-[#E9ECEF] rounded-[8px] w-full flex items-center justify-between">
      <div className="px-3 py-3 flex items-center gap-1 min-w-0">
        <div className="flex items-center gap-1 text-base font-normal leading-[1.5] tracking-[-0.2px]">
          {breadcrumbItems.map((item, index) => {
            const Icon = item.icon;
            const isClickable = item.path !== null;
            
            return (
              <React.Fragment key={`${item.label}-${index}`}>
                {index > 0 && (
                  <ChevronRight className="h-3 w-3 text-gray-400" />
                )}
                {isClickable ? (
                  <button
                    onClick={() => item.path && navigate(item.path)}
                    className="flex items-center gap-1 cursor-pointer hover:text-blue-600 text-gray-700 transition-colors"
                    type="button"
                  >
                    {Icon && <Icon className="h-4 w-4" />}
                    <span>{item.label}</span>
                  </button>
                ) : (
                  <div className="flex items-center gap-1 text-gray-900 font-medium">
                    {Icon && <Icon className="h-4 w-4" />}
                    <span>{item.label}</span>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
      {organization && (
        <div className="hidden sm:flex pr-3">
          <OrganizationPreview organization={organization} />
        </div>
      )}
    </div>
  );
};

export default NewNavbar;
